import { canUseCoverAi, coverAiUpsellAlwaysShown } from 'fym-shared/src/music24/coverEditorPlans';
import type { GetCoverEditorResponse } from '../../../../redux/api/fymAPI.types';

/** The tabs of the Picture panel (design cover-editor b1, c). */
export type PictureTab = 'ai' | 'bank' | 'upload' | 'colour';

/**
 * The first tab of the panel: AI on a plan with AI, with the welcome run of the trial, or when the
 * trial has its welcome pictures (they are the first choices; owner request 2026-10-09); else the
 * bank. Pure.
 */
export function firstPictureTab(input: {
  plan: GetCoverEditorResponse['plan'];
  welcomeRun?: GetCoverEditorResponse['welcomeRun'];
  pictureCount: number;
}): PictureTab {
  if (canUseCoverAi(input.plan) || input.welcomeRun?.available === true) {
    return 'ai';
  }
  return input.pictureCount > 0 && !coverAiUpsellAlwaysShown(input.plan) ? 'ai' : 'bank';
}
